import Link from '../../Link';

class EmbeddedLink extends Link {
  protected static override defaultNewTab = true;
}

export default EmbeddedLink;
